import { __awaiter } from "tslib";
import { Cursor } from './display';
export class UserInput {
    constructor(value = '', cursorPosition = 0, handleSubmit) {
        this.value = value;
        this.cursorPosition = cursorPosition;
        this.handleSubmit = handleSubmit;
        this.enableHistory = true;
        this.historyRoot = '';
        this.historyIdx = -1;
        this.stopSubmitPropagation = false;
        this.focused = false;
        this.stopSubmitPropagation = !!handleSubmit;
    }
    getValue() {
        return this.value;
    }
    focus() {
        this.focused = true;
    }
    blur() {
        this.focused = false;
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.handleSubmit)
                return;
            this.handleSubmit(this.value);
        });
    }
    abortHistory() {
        this.historyRoot = '';
        this.historyIdx = -1;
    }
    moveCursor(offset) {
        const cursorPosition = this.cursorPosition + offset;
        if (cursorPosition < 0 || cursorPosition > this.value.length) {
            return false;
        }
        this.cursorPosition = cursorPosition;
        return true;
    }
    insert(text) {
        let value = this.value.slice(0, this.cursorPosition);
        value += text;
        value += this.value.slice(this.cursorPosition);
        this.value = value;
        this.cursorPosition += text.length;
        this.abortHistory();
    }
    deleteChar() {
        if (!this.cursorPosition) {
            return false;
        }
        this.value = `${this.value.slice(0, this.cursorPosition - 1)}${this.value.slice(this.cursorPosition)}`;
        this.cursorPosition--;
        this.abortHistory();
        return true;
    }
    deleteAll() {
        this.value = '';
        this.cursorPosition = 0;
        this.abortHistory();
    }
    replace(data) {
        this.value = data;
        this.cursorPosition = data.length;
    }
    getTextArray() {
        if (!this.focused) {
            return [
                {
                    text: `> ${this.value}`,
                },
            ];
        }
        let text;
        if (this.cursorPosition === this.value.length) {
            text = [
                {
                    text: `> ${this.value}`,
                },
                Cursor,
            ];
        }
        else {
            const head = this.value.slice(0, this.cursorPosition);
            const tail = this.value.slice(this.cursorPosition + 1);
            text = [
                {
                    text: `> ${head}`,
                },
                {
                    text: this.value[this.cursorPosition],
                    background: 'white',
                    color: 'black',
                    blink: true,
                },
            ];
            if (tail) {
                text.push({ text: tail });
            }
        }
        return [
            {
                text,
            },
        ];
    }
}
export class UserPrompt extends UserInput {
    constructor(question, value = '', cursorPosition = 0, handleSubmit) {
        super(value, cursorPosition, handleSubmit);
        this.question = question;
        this.enableHistory = false;
    }
    getTextArray() {
        const valueText = super.getTextArray();
        const questionText = typeof this.question === 'string' ? [{ text: this.question }] : this.question;
        return [
            {
                text: [...questionText, { text: ' ' }, ...valueText],
            },
        ];
    }
}
export class UserConfirm extends UserPrompt {
    constructor(question, value = '', cursorPosition = 0, handleSubmit) {
        super(`${question} [Y|n]`, value, cursorPosition, handleSubmit);
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.handleSubmit)
                return;
            const value = this.value.trim();
            if (!value) {
                this.value = 'n';
            }
            const confirmed = !!value.match(/^y(a|es|ep|eah)?(!|.)?$/i);
            this.handleSubmit(confirmed);
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlcl9pbnB1dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy93ZWItdGVybWluYWwvdXNlcl9pbnB1dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFRLE1BQU0sRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUV6QyxNQUFNLE9BQU8sU0FBUztJQU9wQixZQUNZLFFBQWdCLEVBQUUsRUFDbEIsaUJBQXlCLENBQUMsRUFDMUIsWUFBbUM7UUFGbkMsVUFBSyxHQUFMLEtBQUssQ0FBYTtRQUNsQixtQkFBYyxHQUFkLGNBQWMsQ0FBWTtRQUMxQixpQkFBWSxHQUFaLFlBQVksQ0FBdUI7UUFUeEMsa0JBQWEsR0FBRyxJQUFJLENBQUM7UUFDckIsZ0JBQVcsR0FBRyxFQUFFLENBQUM7UUFDakIsZUFBVSxHQUFHLENBQUMsQ0FBQyxDQUFDO1FBQ2hCLDBCQUFxQixHQUFHLEtBQUssQ0FBQztRQUMzQixZQUFPLEdBQUcsS0FBSyxDQUFDO1FBT3hCLElBQUksQ0FBQyxxQkFBcUIsR0FBRyxDQUFDLENBQUMsWUFBWSxDQUFDO0lBQzlDLENBQUM7SUFFRCxRQUFRO1FBQ04sT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDO0lBQ3BCLENBQUM7SUFFRCxLQUFLO1FBQ0gsSUFBSSxDQUFDLE9BQU8sR0FBRyxJQUFJLENBQUM7SUFDdEIsQ0FBQztJQUVELElBQUk7UUFDRixJQUFJLENBQUMsT0FBTyxHQUFHLEtBQUssQ0FBQztJQUN2QixDQUFDO0lBRUssTUFBTTs7WUFDVixJQUFJLENBQUMsSUFBSSxDQUFDLFlBQVk7Z0JBQUUsT0FBTztZQUMvQixJQUFJLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNoQyxDQUFDO0tBQUE7SUFFRCxZQUFZO1FBQ1YsSUFBSSxDQUFDLFdBQVcsR0FBRyxFQUFFLENBQUM7UUFDdEIsSUFBSSxDQUFDLFVBQVUsR0FBRyxDQUFDLENBQUMsQ0FBQztJQUN2QixDQUFDO0lBRUQsVUFBVSxDQUFDLE1BQWM7UUFDdkIsTUFBTSxjQUFjLEdBQUcsSUFBSSxDQUFDLGNBQWMsR0FBRyxNQUFNLENBQUM7UUFDcEQsSUFBSSxjQUFjLEdBQUcsQ0FBQyxJQUFJLGNBQWMsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sRUFBRTtZQUM1RCxPQUFPLEtBQUssQ0FBQztTQUNkO1FBRUQsSUFBSSxDQUFDLGNBQWMsR0FBRyxjQUFjLENBQUM7UUFDckMsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBRUQsTUFBTSxDQUFDLElBQVk7UUFDakIsSUFBSSxLQUFLLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFLElBQUksQ0FBQyxjQUFjLENBQUMsQ0FBQztRQUNyRCxLQUFLLElBQUksSUFBSSxDQUFDO1FBQ2QsS0FBSyxJQUFJLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxjQUFjLENBQUMsQ0FBQztRQUMvQyxJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQztRQUNuQixJQUFJLENBQUMsY0FBYyxJQUFJLElBQUksQ0FBQyxNQUFNLENBQUM7UUFDbkMsSUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDO0lBQ3RCLENBQUM7SUFFRCxVQUFVO1FBQ1IsSUFBSSxDQUFDLElBQUksQ0FBQyxjQUFjLEVBQUU7WUFDeEIsT0FBTyxLQUFLLENBQUM7U0FDZDtRQUVELElBQUksQ0FBQyxLQUFLLEdBQUcsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUUsSUFBSSxDQUFDLGNBQWMsR0FBRyxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDLEVBQUUsQ0FBQztRQUN2RyxJQUFJLENBQUMsY0FBYyxFQUFFLENBQUM7UUFDdEIsSUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDO1FBQ3BCLE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUVELFNBQVM7UUFDUCxJQUFJLENBQUMsS0FBSyxHQUFHLEVBQUUsQ0FBQztRQUNoQixJQUFJLENBQUMsY0FBYyxHQUFHLENBQUMsQ0FBQztRQUN4QixJQUFJLENBQUMsWUFBWSxFQUFFLENBQUM7SUFDdEIsQ0FBQztJQUVELE9BQU8sQ0FBQyxJQUFZO1FBQ2xCLElBQUksQ0FBQyxLQUFLLEdBQUcsSUFBSSxDQUFDO1FBQ2xCLElBQUksQ0FBQyxjQUFjLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQztJQUNwQyxDQUFDO0lBRUQsWUFBWTtRQUNWLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFO1lBQ2pCLE9BQU87Z0JBQ0w7b0JBQ0UsSUFBSSxFQUFFLEtBQUssSUFBSSxDQUFDLEtBQUssRUFBRTtpQkFDeEI7YUFDRixDQUFDO1NBQ0g7UUFFRCxJQUFJLElBQVksQ0FBQztRQUNqQixJQUFJLElBQUksQ0FBQyxjQUFjLEtBQUssSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLEVBQUU7WUFDN0MsSUFBSSxHQUFHO2dCQUNMO29CQUNFLElBQUksRUFBRSxLQUFLLElBQUksQ0FBQyxLQUFLLEVBQUU7aUJBQ3hCO2dCQUNELE1BQU07YUFDUCxDQUFDO1NBQ0g7YUFBTTtZQUNMLE1BQU0sSUFBSSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRSxJQUFJLENBQUMsY0FBYyxDQUFDLENBQUM7WUFDdEQsTUFBTSxJQUFJLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLGNBQWMsR0FBRyxDQUFDLENBQUMsQ0FBQztZQUN2RCxJQUFJLEdBQUc7Z0JBQ0w7b0JBQ0UsSUFBSSxFQUFFLEtBQUssSUFBSSxFQUFFO2lCQUNsQjtnQkFDRDtvQkFDRSxJQUFJLEVBQUUsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDO29CQUNyQyxVQUFVLEVBQUUsT0FBTztvQkFDbkIsS0FBSyxFQUFFLE9BQU87b0JBQ2QsS0FBSyxFQUFFLElBQUk7aUJBQ1o7YUFDRixDQUFDO1lBQ0YsSUFBSSxJQUFJLEVBQUU7Z0JBQ1IsSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsQ0FBQyxDQUFDO2FBQzNCO1NBQ0Y7UUFFRCxPQUFPO1lBQ0w7Z0JBQ0UsSUFBSTthQUNMO1NBQ0YsQ0FBQztJQUNKLENBQUM7Q0FDRjtBQUVELE1BQU0sT0FBTyxVQUFXLFNBQVEsU0FBUztJQUd2QyxZQUNZLFFBQXlCLEVBQ25DLFFBQWdCLEVBQUUsRUFDbEIsaUJBQXlCLENBQUMsRUFDMUIsWUFBa0M7UUFFbEMsS0FBSyxDQUFDLEtBQUssRUFBRSxjQUFjLEVBQUUsWUFBWSxDQUFDLENBQUM7UUFMakMsYUFBUSxHQUFSLFFBQVEsQ0FBaUI7UUFIOUIsa0JBQWEsR0FBRyxLQUFLLENBQUM7SUFTN0IsQ0FBQztJQUVELFlBQVk7UUFDVixNQUFNLFNBQVMsR0FBRyxLQUFLLENBQUMsWUFBWSxFQUFFLENBQUM7UUFDdkMsTUFBTSxZQUFZLEdBQUcsT0FBTyxJQUFJLENBQUMsUUFBUSxLQUFLLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxFQUFFLElBQUksRUFBRSxJQUFJLENBQUMsUUFBUSxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQztRQUVuRyxPQUFPO1lBQ0w7Z0JBQ0UsSUFBSSxFQUFFLENBQUMsR0FBRyxZQUFZLEVBQUUsRUFBRSxJQUFJLEVBQUUsR0FBRyxFQUFFLEVBQUUsR0FBRyxTQUFTLENBQUM7YUFDckQ7U0FDRixDQUFDO0lBQ0osQ0FBQztDQUNGO0FBRUQsTUFBTSxPQUFPLFdBQVksU0FBUSxVQUFVO0lBQ3pDLFlBQ0UsUUFBeUIsRUFDekIsUUFBZ0IsRUFBRSxFQUNsQixpQkFBeUIsQ0FBQyxFQUMxQixZQUFrQztRQUVsQyxLQUFLLENBQUMsR0FBRyxRQUFRLFFBQVEsRUFBRSxLQUFLLEVBQUUsY0FBYyxFQUFFLFlBQVksQ0FBQyxDQUFDO0lBQ2xFLENBQUM7SUFFSyxNQUFNOztZQUNWLElBQUksQ0FBQyxJQUFJLENBQUMsWUFBWTtnQkFBRSxPQUFPO1lBRS9CLE1BQU0sS0FBSyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFLENBQUM7WUFDaEMsSUFBSSxDQUFDLEtBQUssRUFBRTtnQkFDVixJQUFJLENBQUMsS0FBSyxHQUFHLEdBQUcsQ0FBQzthQUNsQjtZQUVELE1BQU0sU0FBUyxHQUFHLENBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLDBCQUEwQixDQUFDLENBQUM7WUFDNUQsSUFBSSxDQUFDLFlBQVksQ0FBQyxTQUFTLENBQUMsQ0FBQztRQUMvQixDQUFDO0tBQUE7Q0FDRiJ9